import { Controller } from "@hotwired/stimulus"

// Akcje pulpitu widoczne poza edycja (toolkit/dashboards/_widgets): "Dostosuj pulpit" i wybor pulpitu z selecta
// (na /cms jest w podgladzie) doczytuja bundle controllers/index_dashboard z kontrolerem dashboard-layout
// (przeciaganie, ustawienia, zapis) i przekazuja mu akcje. Bundle laduje sie raz na karte - kolejne pulpity (tez po nawigacji Turbo) maja go od razu.
let loading = null
const registeredApps = new WeakSet()

function loadBundle(src) {
  loading ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = src
    script.onload = resolve
    script.onerror = () => {
      loading = null
      script.remove()
      reject(new Error(`dashboard bundle: ${src}`))
    }
    document.head.appendChild(script)
  })
  return loading
}

export default class extends Controller {
  static values = { src: String }

  async edit() {
    (await this.layout())?.edit()
  }

  // event.currentTarget po await jest juz null - przekazujemy sam select
  async select(event) {
    const select = event.currentTarget
    ;(await this.layout())?.select({ currentTarget: select })
  }

  // Rejestrujemy dashboard-layout w aplikacji tego kontrolera, a nie w window.Stimulus - bundle modulow
  // (index_crm, index_noe...) startuja wlasne aplikacje i nadpisuja window.Stimulus, wiec po nawigacji
  // Turbo (np. / -> /crm) kontroler bylby zarejestrowany w innej aplikacji niz ta, w ktorej go szukamy
  async layout() {
    await loadBundle(this.srcValue)
    if (!registeredApps.has(this.application)) {
      this.application.register("dashboard-layout", window.IntumDashboardLayoutController)
      registeredApps.add(this.application)
    }
    return this.application.getControllerForElementAndIdentifier(this.element, "dashboard-layout")
  }
}
